import APIService from "../services/APIService";
import { cartActions } from "../store/cart-slice";

const refreshCartPrices = async (dispatch, itemsList) => {
  const updatedItems = await Promise.all(
    itemsList.map(async (item) => {
      try {
        const product = await APIService.GetProductBySlug(item.product.slug);
        return {
          ...item,
          product: {
            ...product,
            unit_price: product.price_info?.price || 0,
          },
        };
      } catch (error) {
        console.error("Greška pri osvežavanju cene:", error);
        return item;
      }
    })
  );

  dispatch(cartActions.resetCart());
  updatedItems.forEach((item) => {
    dispatch(
      cartActions.addToCart({
        product: item.product,
        quantity: item.quantity,
      })
    );
  });
};
export default refreshCartPrices;
